// removed by extract-text-webpack-plugin
module.exports = {"Loader":"_1DDwYTkbvNoVwBDs8ZptVg","load1":"_3Y-9zaLiN1mD6VNVa9-DVx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 235
// module chunks = 0